import React from 'react'
import { Card, StyledBody, StyledAction } from 'baseui/card'
import { Button } from 'baseui/button'
import { navigate } from 'gatsby'
import { useStyletron } from 'styletron-react'

const CollectionCard = ({ collection }) => {
  const [css, theme] = useStyletron()
  const imageProps = {
    srcSet: collection.image.localFile.childImageSharp.fluid.srcSet,
    src: collection.image.localFile.childImageSharp.fluid.src,
  }

  return (
    <Card
      headerImage={imageProps}
      title={collection.title}
      className={css({ marginBottom: '1rem' })}
      overrides={{
        Root: {
          style: ({ $theme }) => {
            return {
              borderTopColor: $theme.colors.border,
              borderLeftColor: $theme.colors.border,
              borderBottomColor: $theme.colors.border,
              borderRightColor: $theme.colors.border,
              marginBottom: '1rem',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }
          },
        },
        HeaderImage: {
          style: {
            height: '130px',
            margin: '1rem',
          },
        },
      }}
    >
      <StyledBody
        className={css({ minHeight: '196px' })}
        dangerouslySetInnerHTML={{ __html: collection.descriptionHtml }}
      />
      <StyledAction>
        <Button
          onClick={() => navigate(`/collections/${collection.handle}`)}
          overrides={{ BaseButton: { style: { width: '100%' } } }}
        >
          {collection.title}
        </Button>
      </StyledAction>
    </Card>
  )
}

export default CollectionCard
